import styled from "styled-components"

import Button from "components/presenters/common/form/Button"
import SVGIcon from "components/presenters/common/SVGIcon"

export default function PaybackLink() {
  return (
    <LinkStyle to="/motishop/payback" fullWidth>
      마이페이지에서 환급내역을 볼 수 있어요!
      <ArrowIconBlock>
        <SVGIcon name="arrow" />
      </ArrowIconBlock>
    </LinkStyle>
  )
}

const LinkStyle = styled(Button)`
  display: flex;
  justify-content: space-between;
  background-color: #4e4e4e;
  box-shadow: 0px 0px 20px rgba(191, 191, 191, 0.74);
  color: #fefefe;
  font-style: normal;
  font-weight: 400;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  padding: calc(100vw * (20 / 375)) calc(100vw * (16 / 375));
`

const ArrowIconBlock = styled.div`
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (14 / 375));

  svg {
    color: #fff;
  }
`
